import { render, staticRenderFns } from "./ClCheckbox.html?vue&type=template&id=f31641aa&"
import script from "./ClCheckbox.ts?vue&type=script&lang=ts&"
export * from "./ClCheckbox.ts?vue&type=script&lang=ts&"
import style0 from "./ClCheckbox.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports